// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main .bottom[data-v-1d4c47e4] {\n  position: fixed;\n  bottom: 0;\n  z-index: 10;\n  width: 100%;\n  padding-bottom: env(safe-area-inset-bottom);\n  background: #ffffff;\n}", ""]);
// Exports
module.exports = exports;
